export enum issueStatusHistory {
  dismissed = 'dismissed',
  open = 'open',
  fixed = 'fixed',
  partiallyFixed = 'partiallyFixed',
  notFixed = 'notFixed',
  notReproducible = 'notReproducible',
  cannotBeFixed = 'cannotBeFixed',
}
